import { Col, Row } from "@commonlibs";
import { alpha } from "@commonlibs";
import styled, { css } from "styled-components";

export const FormGridRowRoot = styled(Row)<{ viewOnly?: boolean }>(
    ({ theme, viewOnly }) => css`
        background-color: ${viewOnly ? "#F5F5F5" : "white"};
        ${theme.breakpoints.down("mobile")} {
            max-height: unset;
            flex-direction: column;
        }
    `,
);

export const FormGridCell = styled(Col)(
    ({ theme }) => css`
        justify-content: center;
        transition: background-color 0.3s;
        &:active.editable {
            background-color: ${alpha(theme.palette.primary, 0.12)};
        }
    `,
);

export const FormGridLeftCell = styled(FormGridCell)(
    ({ theme: { border, spacing, breakpoints } }) => css`
        width: 17rem;
        padding: ${spacing.all(5, 4)};
        ${breakpoints.down("mobile")} {
            width: 100%;
            border-right: unset;
            border-bottom: ${border.sm};
        }
    `,
);

export const FormGridRightCell = styled(FormGridCell)(
    () => css`
        flex: 1;
    `,
);
